import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Loca',
    component: () => import(/* webpackChunkName: "Loca" */ '../views/Loca.vue')
  },
  {
    path: '/locapromotion',
    name: 'Locapromotion',
    component: () => import(/* webpackChunkName: "locapromotion" */ '../views/locapromotion.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
